import React, { useState } from 'react';
import { Users, UserPlus } from 'lucide-react';
import Header from '../../components/header';
import TeamsList from './TeamsList';
import TeamMembersList from './TeamMembersList';
import './teams.scss';

const TeamsManagement = () => {
  const [activeTab, setActiveTab] = useState('members');

  return (
    <div id="main" className="main">
      <Header />
      <section className="content-section-1">
        <div className="teams-management-container">
          <div className="teams-header">
            <h2 className="teams-title">
              <Users size={24} />
              Manage Teams
            </h2>
          </div>

          <div className="teams-tabs">
            <button
              className={`tab-button ${activeTab === 'members' ? 'active' : ''}`}
              onClick={() => setActiveTab('members')}
            >
              <UserPlus size={18} />
              Team Members
            </button>
            <button
              className={`tab-button ${activeTab === 'teams' ? 'active' : ''}`}
              onClick={() => setActiveTab('teams')}
            >
              <Users size={18} />
              Teams
            </button>
          </div>

          <div className="teams-content">
            {activeTab === 'members' ? <TeamMembersList /> : <TeamsList />}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeamsManagement;